<template>
  <div
    v-if="!loadding"
    class="confirm-wrap"
  >
    <div
      class="text-c666 font-s16 mt-24 mb-16"
    >
      {{ TLang('填写并核对收货信息', 'orderConfirm') }}
    </div>
    <div class="border-ce5">
      <!-- address 订单收货地址模块 -->
      <orderAddress
        :defaultAddressId="addressId"
        :addressList="addressList"
        :loadding="!loadding"
        :editAddressItem="address"
        :newAddressNotice="newAddressNotice"
        :invalideDialog="invalideDialog"
        :onSetDefaultAddress="onSetDefaultAddress"
        :onEdit="onEdit"
        :onAdd="onAdd"
      />
      <div class="line"></div>
      <orderHaitaoForm
        v-if="hasHaitao"
        ref="haitaoInfo"
      />
      <div
        v-if="hasHaitao"
        class="line"
      ></div>
      <!-- merchantList 中为可售商品 props buyGoodsList -->
      <merchantList :buyGoodsList.sync="buyGoodsList" />
      <!-- notSaleProductsList 不可售商品列表 props notSaleProducts -->
      <notSaleProductsList :notSaleProducts="notSaleProducts" />
    </div>
    <div class="order-control">
      <div class="border-ce5 mt-16">
        <div class="settle-wrap">
          <div class="settle-wrap-item">
            <span
              class="font-c666"
            >
              {{ TLang("totalProduct1", "orderConfirm") }}
              <em class="font-s14">{{ settleAccountInfo.orderTotalNums }}</em>
              {{ TLang("totalProduct2", "orderConfirm") }}，{{ TLang('商品总价','list') }}({{ settleAccountInfo.union_name }}):
            </span>
            <span class="text-num-c111">
              {{
                settleAccountInfo.orderTotalGoodsAmount
              }}
            </span>
          </div>
          <div class="settle-wrap-item mt-12">
            <span
              class="font-c666"
            >{{ TLang('运费', 'orderConfirm') }}({{ settleAccountInfo.union_name }}):</span>
            <span class="text-num-c111">
              {{
                settleAccountInfo.orderTotalFeight
              }}
            </span>
          </div>
          <div
            v-if="settleAccountInfo.reducePrice"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang('优惠', 'list') }}({{ settleAccountInfo.union_name }}):</span>
            <span class="text-num-c111">-{{ settleAccountInfo.reducePrice }}</span>
          </div>
          <div class="settle-wrap-item mt-12">
            <span class="font-c666">{{ TLang('应付金额', 'orderConfirm') }}</span>
            <span>
              <img
                :src="settleAccountInfo.fudou"
                alt
                class="fudou-15"
              />
              <em class="text-num-bold-red font-s20">
                {{
                  settleAccountInfo.orderAccountPayable
                }}
              </em>
            </span>
          </div>
          <div class="settle-wrap-item mt-20 clearfix">
            <div
              id="create-order"
              v-loading.fullscreen.lock="createOrderDisabled"
              class="btn-theme-w150 fr"
              :class="{'order-disable': all_valided }"
              @click="
                () => {
                  onCreateOrder();
                }
              "
            >
              {{TLang('提交订单','list')}}
            </div>
          </div>
          <div class="mt-12 text-right">
            <span
              class="dib mr-8 font-c999"
            >{{ TLang('收货信息', 'orderConfirm') }}：{{ settleAccountInfo.consigneeInfo }}</span>
            <span class="font-c999">{{ settleAccountInfo.addressInfo }}</span>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      title=" "
      :visible="invalideDialog && !editAddressDialog"
      width="420px"
      close-on-click-modal
      custom-class="order-invalide-dialog"
      center
      top="50vh"
      :show-close="false"
      @open="invalideDialog = true"
      @close="invalideDialog = false"
    >
      <img :src="require('@assets/images/smallBell.png')" />
      <p class="desc part_valided">
        {{ confirmOrderTips }}
      </p>
      <div>
        <button
          class="btns close"
          @click="closeDialog"
        >
          {{TLang('我知道了','list')}}
        </button>
        <a
          v-if="all_valided"
          class="btns back"
          :href="backLink"
          target="_self"
        >{{ all_valideButton }}</a>
      </div>
    </Dialog>
    <Dialog
      :title="TLang('信息确认', 'orderConfirm')"
      :visible="birthdayRemarkModal"
      width="528px"
      close-on-click-modal
      custom-class="birthday-nuoxin-dialog"
      center
      top="50vh"
      @open="birthdayRemarkModal = true"
      @close="birthdayRemarkModal = false"
    >
      <div class="content">
        <!-- <h3>信息确认</h3> -->
        <p>
          <span class="head-text">{{TLang('生日牌内容','list')}}</span>
          <span class="userremark">{{ userRemark || TLang('生日快乐','list') }}</span>
        </p>
        <div class="nuoxin-footer">
          <div
            v-loading.fullscreen.lock="createOrderDisabled"
            class="nuoxin-confirm"
            @click="onCreateOrder"
          >
            {{TLang('提交订单','list')}}
          </div>
          <div
            class="nuoxin-close"
            @click="birthdayRemarkModal = false"
          >
            {{TLang('返回修改','list')}}
          </div>
        </div>
      </div>
    </Dialog>
    <Popups
      v-if="!union_isBilingual"
      ref="popus"
      :showCancel="isShowCancel"
      :showPopus="editAddressDialog"
      :title="addressDialog.title"
      :addressItem="addressDialog.addressItem"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
    />
    <PopupsEn
      v-if="union_isBilingual"
      ref="popus"
      :showCancel="isShowCancel"
      :showPopus="editAddressDialog"
      :title="addressDialog.enTitle"
      :addressItem="addressDialog.addressItem"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ConfirmDialog from '@components/confirmDialog';
import Cookies from 'js-cookie';
import { getQueryString, unionFlag } from '@utils/index';
import merchantList from './components/merchantList';
import notSaleProductsList from './components/notSaleProductList';
import orderSettle from './components/orderSettle';
import orderAddress from './components/orderAddress';
import orderHaitaoForm from './components/orderHaitaoForm';
import Loading from '@components/SimpleLoading';
import { confirmOrder, createOrder } from '@fetch/order';
import { Dialog } from 'element-ui';
import Popups from './components/orderAddress/popups';
import PopupsEn from './components/orderAddress/popupsEn';
import Toast from '@components/simpleToast';
import { sendPost } from '@utils/request';
import {
  fetchAddressList,
  fetchAddressUpdate,
  fetchAddressCreate,
  fetchAddressDelete,
} from '@fetch/address';

export default {
  name: 'OrderConfirmV2',
  components: {
    orderAddress, //地址模块
    merchantList, //可售商品模块
    notSaleProductsList, //失效商品模块
    orderSettle, // 订单支付模块
    ConfirmDialog,
    orderHaitaoForm,
    Dialog,
    Popups,
    PopupsEn,
  },
  data() {
    return {
      isShowCancel: true,
      isFirstLoad: true, // 是否第一次加载
      isCallBackReload: false, // 地址添加窗口关闭后是否要触发重新加载地址
      addressId: 0, // 默认收货地址 id
      address: null, // 收货地址
      goodsList: [], // 下单商品信息
      loadding: true,
      confirmDialog: false,
      confirmOrderTips: TLang('orderGoodsInvalid', 'orderConfirm'),
      newAddressNotice: false,
      invalideDialog: false,
      all_valided: false,
      part_valided: false,
      backLink: '',
      editdialog: false,
      addressDialog: {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang('新增收货地址', 'orderConfirm'),
        enTitle: this.TLang('新增收货地址', 'orderConfirm'),
        addressItem: null,
      }, // 地址新建、编辑弹层
      editAddressDialog: false,
      isReload: false, // 关闭弹窗是否需要刷新页面
      birthdayRemarkModal: false, // 诺心生日牌确认弹框
      userRemark: '', // 生日牌内容
      editAddressItem: {},
      addressList: [],
      createOrderDisabled: false,
    };
  },
  computed: {
    ...mapState('orderConfirm', [
      'hasHaitao',
      'createCode',
      'createOrderParameter',
      'confirmInfo'
    ]),
    ...mapState({
      buyGoodsList: (state) => state.orderConfirm.buyGoodsList,
      notSaleProducts: (state) => state.orderConfirm.notSaleGoodsList,
      settleAccountInfo: (state) => state.settleAccountInfo,
    }),
    ...mapGetters('orderConfirm', {
      buyGoodsList: 'getBuyGoodsList', // 可购买的商品
      settleAccountInfo: 'getSettleAccountInfo', // 订单结算总计
      userAddressList: 'getUserAddressList',
      notSaleGoodsList: 'getNotSaleGoodsList',
    }),
  },
  watch: {
    buyGoodsList(oval, nval) {
      if (!nval) return null;
      if (oval == nval) return;
      this.loadding = false;
      Loading.hide();
    },
    notSaleGoodsList: {
      handler(oldVal, newVal) {
        this.checkIsShowGoodsTip();
      },
      deep: true,
    },
  },
  created() {
    this.isFirstLoad = true;
    this.initData();
  },
  mounted() {
    // if (this.loadding && !this.address.id) {
    //   this.editAddressDialog = !this.editAddressDialog;
    //   this.addressDialog.addressItem = this.editAddressItem;
    // }
  },
  methods: {
    ...mapActions('orderConfirm', ['getConfirmOrder', 'createOrder']),
    ...mapActions('address', [
      'addAddress',
      'editAddress',
      'getAddressDetailById'
    ]),
    initData() {
      // this.buyGoodsList = []; //切换地址赋初值
      setTimeout(() => {
        this.handleAddress();
        // const url = '/address/userNewAddressContract/queryUserAddressListV2';
        // return sendPost({ url }).then(res => res);
      }, 100);
    },
    // 根据条件判断是否要显示弹窗
    checkIsShowGoodsTip() {
      this.editdialog = !this.address.id;
      this.all_valided =
        this.notSaleGoodsList &&
        this.notSaleGoodsList.length > 0 &&
        (!this.buyGoodsList || this.buyGoodsList.length === 0);
      this.part_valided =
        this.notSaleGoodsList &&
        this.notSaleGoodsList.length > 0 &&
        this.buyGoodsList &&
        this.buyGoodsList.length > 0;
      this.invalideDialog = this.all_valided || this.part_valided;
      // console.log(editdialog)
      this.formatCreateOrderTips();
    },
    getAddressList(defaultId) {
      // debugger
      fetchAddressList({ channel: unionFlag() ? 2 : 1 }).then((res) => {
        if (res.length) {
          res.map((item, index) => {
            if (item.id === defaultId) {
              res.unshift(res.splice(index, 1)[0]);
            }
          });
          this.$set(this, 'addressList', res);
        }
        this.checkDefaultAddress(res);
        this.confirmOrder();
      });
    },
    // 验证是否要弹出地址添加窗口
    checkDefaultAddress(res) {
      this.isShowCancel = true;
      this.isCallBackReload = false;
      // this.address.id 判断是否是长地址
      if (
        this.address === undefined ||
        this.address === null ||
        this.address.id === null ||
        this.address.id === undefined
      ) {
        // 用户地址库没有数据弹出地址添加窗口
        if (res.length <= 0) {
          this.isShowCancel = false;
          this.editAddressDialog = !this.editAddressDialog;
          this.addressDialog.addressItem = this.editAddressItem;
          return;
        }
        // 不是长地址匹配用户地址库中是否有匹配项
        let list = res.filter(
          (t) =>
            t.provinceName === this.address.provinceName &&
            t.cityName === this.address.cityName &&
            t.regionName === this.address.regionName &&
            t.streetName === this.address.streetName,
        );
        if (list.length <= 0) {
          list = res.filter(
            (t) =>
              t.provinceName === this.address.provinceName &&
              t.cityName === this.address.cityName &&
              t.regionName === this.address.regionName,
          );
        }
        if (list.length <= 0) {
          list = res.filter(
            (t) =>
              t.provinceName === this.address.provinceName &&
              t.cityName === this.address.cityName,
          );
        }
        if (list.length <= 0) {
          list = res.filter(
            (t) => t.provinceName === this.address.provinceName,
          );
        }
        let userAddress = null;
        if (list.length > 0) {
          // 如果有多条匹配地址,如果只有一条直接取值
          if (list.length > 1) {
            // 获取所有默认地址,如果没有默认地址取第一条
            let das = list.filter((t) => t.defaultAddress === 1);
            if (das.length > 0) {
              userAddress = das[0];
            } else {
              userAddress = list[0];
            }
          } else {
            userAddress = list[0];
          }
        } else {
          // 短地址匹配不到长地址给默认地址,弹出添加窗口
          if (this.isFirstLoad) {
            this.isShowCancel = true;
            this.isFirstLoad = false;
            this.isCallBackReload = true;
            userAddress = null;
          } else {
            // 没有默认地址取top1
            const das = res.filter((t) => t.defaultAddress === 1);
            if (das.length > 0) {
              userAddress = das[0];
            } else {
              userAddress = res[0];
            }
          }
        }
        if (userAddress) {
          this.addressId = userAddress.id;
          this.address = userAddress;
          Cookies.set('address', userAddress, { expires: 365 });
          console.log('Cookies.set5', userAddress);
          this.initData();
        } else {
          this.editAddressDialog = !this.editAddressDialog;
          this.addressDialog.addressItem = this.editAddressItem;
        }
      }
    },
    onEdit(address) {
      this.editAddressDialog = true;
      this.addressDialog = {
        dialogState: false,
        title: this.TLang('编辑收货地址', 'orderConfirm'),
        enTitle: this.TLang('编辑收货地址', 'orderConfirm'),
        addressItem: address,
      };
    },
    onAdd() {
      if (this.addressList.length >= 25) return;
      this.addressDialog = {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang('新增收货地址', 'orderConfirm'),
        enTitle: this.TLang('新增收货地址', 'orderConfirm'),
        addressItem: null,
      };
      this.editAddressDialog = true;
    },
    onSetDefaultAddress(address) {
      fetchAddressUpdate({
        ...address,
        defaultAddress: 1,
        channel: unionFlag() ? 2 : 1,
      }).then((res) => {
        this.getAddressList(this.addressId);
      });
    },
    handleAddress() {
      let addressFromCookie = Cookies.get('address');
      if (!addressFromCookie)
        throw Error(
          this.TLang('errorAddressTips2', 'orderConfirm'),
        );
      if (addressFromCookie === 'undefined' || addressFromCookie === 'null') {
        throw Error(this.TLang('errorAddressTips', 'orderConfirm'));
        Cookies.remove('address');
        this.$router.push('/');
      }
      const add = JSON.parse(addressFromCookie);
      if(this.address === null || this.address.id === undefined) {
        this.address = add;
      } else if(this.address !== null && add.id !== undefined) {
        this.address = add;
      }
      this.handleAddressLogic();
    },
    handleBuyGoodsList() {
      const buyGoodsList = getQueryString('buyGoodsList');
      if (!buyGoodsList)
        throw Error(this.TLang('errorAddressTips3', 'orderConfirm'));
      this.goodsList = JSON.parse(buyGoodsList) || [];
    },
    // 编辑/新增 地址
    onConfirmEditAddressDialog(item) {
      if (this.addressList.length >= 25 && this.addressDialog.dialogState) {
        Toast.info(this.TLang('最多只能创建25条收货地址', 'orderConfirm'));
        return;
      }
      this.addressDialog.dialogState
        ? this.addAddress(item)
        : this.editAddress(item);
    },
    onCancelEditAddressDialog() {
      if (this.isCallBackReload) {
        this.getAddressList(this.addressId);
      }
      this.addressDialog.dialogState = true;
      this.addressDialog.title = this.TLang('新建收货地址', 'orderConfirm');
      this.addressDialog.addressItem = {};
      this.editAddressDialog = false;
    },
    /**
     * 短地址渲染
     */
    handleAddressLogic() {
      const { id } = this.address;
      if (!id) {
        this.editAddressItem = this.address;
      } else {
        this.addressId = id;
      }
      this.handleBuyGoodsList();
      this.getAddressList(this.addressId);
    },
    confirmOrder() {
      const { goodsList, addressId, address } = this;
      let confirmOrderParameters = {}; // 确认订单参数
      if (!address || !goodsList.length) return;
      if (!addressId) {
        confirmOrderParameters = {
          buyGoodsList: goodsList,
          ...address,
        };
      } else {
        confirmOrderParameters = {
          buyGoodsList: goodsList,
          addressId,
          platform: 0,
        };
      }

      (this.loadding = true), Loading.show();
      this.getConfirmOrder(confirmOrderParameters);
      // setTimeout(() => {
      //   this.editdialog = !this.address.id;
      //   this.all_valided =
      //     this.notSaleGoodsList &&
      //     this.notSaleGoodsList.length > 0 &&
      //     (!this.buyGoodsList || this.buyGoodsList.length === 0);
      //   this.part_valided =
      //     this.notSaleGoodsList &&
      //     this.notSaleGoodsList.length > 0 &&
      //     this.buyGoodsList &&
      //     this.buyGoodsList.length > 0;
      //   this.invalideDialog = this.all_valided || this.part_valided;
      //   // console.log(editdialog)
      //   this.formatCreateOrderTips();

      //   // console.log(this.all_valided, this.part_valided, 'buyGoodsList');
      // }, 1000);
    },
    formatCreateOrderTips() {
      const orderType = getQueryString('orderType');
      const buyGoodsList = getQueryString('buyGoodsList') || [];
      const { goodsId, categoryId } = JSON.parse(buyGoodsList)[0] || {};
      if (this.all_valided) {
        if (Number(orderType) === 2) {
          this.confirmOrderTips = this.TLang('orderGoodsInvalid', 'orderConfirm');
          this.backLink = `/shop/product/detail?cid=${categoryId}&gid=${goodsId}`;
          this.all_valideButton = this.TLang('返回详情页', 'orderConfirm');
        } else if (Number(orderType) === 1) {
          this.confirmOrderTips = this.TLang('orderGoodsInvalid', 'orderConfirm');
          this.backLink = '/shop/shopping/cart';
          this.all_valideButton = this.TLang('返回购物车', 'orderConfirm');
        }
      }
      if (this.part_valided) {
        this.confirmOrderTips =
          this.TLang('goodsInvError', 'orderConfirm');
      }
    },
    createOrderAction() {
      if (this.hasHaitao) {
        this.$refs.haitaoInfo.$refs['haitaoForm'].validate((valid) => {
          v = valid;
        });
      }
      if (this.addressList.length === 0) {
        this.newAddressNotice = !this.newAddressNotice;
      }
      if (document.getElementById('userRemark') && !this.birthdayRemarkModal) {
        this.loadding = false;
        Loading.hide();
        this.createOrderDisabled = false;
        this.birthdayRemarkModal = true;
        this.userRemark =
          document.getElementById('userRemark').value || this.TLang('生日快乐', 'list');
        console.log(document.getElementById('userRemark').value);
        return;
      }

      // 提交订单 异常判断
      /**
       *  GOODS_SOLDOUT(7,"商品已下架"),
       *   GOODS_STOCK_OOS(8,"商品库存不足"),
       */
      createOrder(this.createOrderParameter).then((res) => {
        this.createOrderDisabled = false;
        if (res.code && res.code === 7) {
          this.confirmOrderTips = this.TLang('goodsXiaJia', 'orderConfirm');
          this.invalideDialog = true;
          this.isReload = true;
          return;
        }
        if (res.code && res.code === 8) {
          this.confirmOrderTips = this.TLang('addressError', 'orderConfirm');
          this.invalideDialog = true;
          this.isReload = true;
          return;
        }
        if (res.code && res.msg) {
          Toast.info(res.msg);
          return;
        }
        window.location.href = res.body;
      });
    },
    closeDialog() {
      this.invalideDialog = false;
      if (this.isReload) {
        window.location.reload();
      }
    },
    onCreateOrder() {
      this.createOrderDisabled = true;
      const { addressId } = this.createOrderParameter;
      let isCreateOrder = true;
      let errorMsg = '';
      if (this.all_valided) return;
      if (!addressId) {
        this.$message.error(this.TLang('请选择用户的配送地址', 'orderConfirm'));
        return;
      }
      if (this.createOrderParameter && this.createOrderParameter.buyInfoList) {
        this.createOrderParameter.buyInfoList.map((item) => {
          if (item.deliveryWay === '3' && !item.expectDeliveryTime) {
            errorMsg = this.TLang('请选择发货时间', 'orderConfirm');
            isCreateOrder = false;
            return;
          }

          if (item.deliveryWay === '3' && item.expectDeliveryTime) {
            const m =
              new Date(item.expectDeliveryTime).getMonth() ===
              new Date().getMonth();
            const d =
              new Date(item.expectDeliveryTime).getDate() ===
              new Date().getDate();
            // const splitcutOffTimeStr = item.cutOffTimeStr
            //   ? item.cutOffTimeStr.split(':')
            //   : [0, 0];
            // let timeout = false;
            // if (
            //   new Date().getHours() === Number(splitcutOffTimeStr[0]) &&
            //   new Date().getMinutes() > Number(splitcutOffTimeStr[1])
            // ) {
            //   timeout = true;
            // } else if (new Date().getHours() > Number(splitcutOffTimeStr[0])) {
            //   timeout = true;
            // }

            if (m && d  && item.deliveryWay === '3') {
              errorMsg = this.TLang('请修改发货时间', 'orderConfirm');
              isCreateOrder = false;
              return;
            }
          }
        });
      }

      if (!isCreateOrder) {
        this.$message.error(errorMsg);
        return;
      }

      this.createOrderAction();
    },
  },
};
</script>

<style lang="less">
.confirm-wrap {
  .order-control {
    .settle-wrap {
      .card-theme;
      padding: 24px;

      .settle-wrap-item {
        text-align: right;
        span {
          display: inline-block;

          &:last-of-type {
            width: 11%;
          }
        }
      }
    }
  }
  .birthday-nuoxin-dialog {
    transform: translateY(-50%);
    .content {
      .nuoxin-footer {
        display: flex;
        justify-content: center;
        margin-top: 44px;
        .nuoxin-confirm,
        .nuoxin-close {
          width: 120px;
          height: 40px;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
        }
        .nuoxin-confirm {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
        .nuoxin-close {
          border: 1px solid rgba(229, 229, 229, 1);
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin-left: 20px;
        }
      }
      p {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
        .userremark {
          color: #111;
          word-break: break-all;
        }
      }
    }
  }
  .order-invalide-dialog {
    transform: translateY(-50%);
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      .title {
        font-size: 18px;
        color: #333;
        font-weight: 400;
      }
      .desc {
        margin-top: 14px;
      }
      .part_valided {
        font-size: 18px;
        padding: 0 50px;
      }
      .btns {
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(315deg, #5cb4ec, #3d96e2);
        width: 88px;
        margin-top: 20px;
        display: inline-block;
      }
      .back {
        margin-left: 20px;
        border: 1px solid #3d96e2;
        background: #fff;
        color: #3d96e2;
      }
      .close {
        // border: 1px solid #3d96e2;
        // background: #fff;
        // color: #3d96e2;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .order-disable {
    background: #ccc;
  }
}
</style>
